/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountActivationAliases {
  BUTTON_CLOSE_MODAL = 'button-close-modal',
  BUTTON_GO_LOGIN = 'button-go-login',
  IMAGE_SUCCESS = 'image-success',
  LAYOUT_ACCOUNT_ACTIVATION = 'layout-account-activation',
  LAYOUT_CONTENT = 'layout-content',
  LOADER_ACTIVATE = 'loader-activate',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  TEXT_SUCCCESS_SUBTITLE = 'text-succcess-subtitle',
  TEXT_SUCCCESS_SUBTITLE_2 = 'text-succcess-subtitle-2',
  TEXT_SUCCESS_TITLE = 'text-success-title',
}
export { AccountActivationAliases };
